import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";
import { useAuth } from "../AuthContext";
import { useI18n } from "../I18nContext";

function stamp(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${y}-${m}-${day} ${hh}:${mm}`;
}

function visLabel(vis, t) {
  if (vis === "shared_accelerator") return t("team1v1.sharedAccelerator");
  if (vis === "private") return t("team1v1.private");
  return t("team1v1.shared");
}

function sessionHref(note) {
  return note.session_type === "internal_1_1"
    ? `/app/team-1-1/${note.session_id}`
    : `/app/sessions/${note.session_id}`;
}

export default function PortfolioNotes({ founderId }) {
  const { user } = useAuth();
  const { t } = useI18n();
  const [notes, setNotes] = useState(null);
  const [err, setErr] = useState("");
  const ownerId = founderId || user?.id;

  useEffect(() => {
    if (!ownerId) return;
    setErr("");
    setNotes(null);
    api.get(`/users/${ownerId}/notes`)
      .then((r) => setNotes(r.data || []))
      .catch((e) => {
        setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        setNotes([]);
      });
  }, [ownerId]);

  if (notes === null) return <div className="tb-loading">{t("common.loading")}</div>;

  return (
    <div data-testid="portfolio-notes">
      <p className="tb-muted" style={{ marginTop: 0 }}>{t("portfolio.notesHint")}</p>
      {err && <div className="tb-form-error" style={{ marginBottom: 12 }}>{err}</div>}
      {notes.length === 0 ? (
        <p className="tb-muted" data-testid="portfolio-notes-empty">{t("portfolio.notesEmpty")}</p>
      ) : (
        <div className="tb-card-grid">
          {notes.map((n) => (
            <article key={n.id} className="tb-app-card" data-testid={`portfolio-note-${n.id}`}>
              <span className="tb-when">{stamp(n.created_at)}</span>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                <span className={`tb-badge ${n.visibility === "private" ? "muted" : "good"}`}>{visLabel(n.visibility, t)}</span>
              </div>
              <p style={{ whiteSpace: "pre-wrap", margin: "4px 0" }}>{n.body}</p>
              <small>
                {[n.author_name, n.session_title].filter(Boolean).join(" · ")}
                {n.session_at ? ` · ${stamp(n.session_at)}` : ""}
              </small>
              {n.session_id && (
                <Link to={sessionHref(n)} style={{ fontSize: "0.85rem" }}>{t("portfolio.noteMeeting")}</Link>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
